import CreateEditUserRole from "../../Components/UserRoleManagement/CreateEditUserRole"
import { useLocation } from "react-router-dom"
export default function UserRoleCreateEdit() {
    const location = useLocation()
    const isEditUserRole = location.pathname.includes("/edit-userrole")
    const selectedRow = isEditUserRole?location?.state?.userRole:undefined
    return (
        <CreateEditUserRole  selectedRow={selectedRow}/>
    )
}